import LogoMain from '@/assets/svg/logos/logo-main.svg';
import { theme, Typography } from '@/design-system';

import { Header, Main, NoticeButton, Shell } from '../full-page-notice/styled';

type ErrorPageProps = {
  onRetry: () => void;
};

export const ErrorPage = ({ onRetry }: ErrorPageProps) => (
  <Shell>
    <Header>
      <LogoMain role="img" aria-label="Gamma Prime" />
    </Header>
    <Main>
      <Typography variant="h4" as="h1">
        Something went wrong
      </Typography>
      <Typography variant="body2" color={theme.colors.text.secondary}>
        The page couldn’t load. Try again, or reload the page if the problem continues.
      </Typography>
      <NoticeButton type="button" size="lg" onClick={onRetry}>
        Try again
      </NoticeButton>
    </Main>
  </Shell>
);
